import React from "react" 
import { FiClock } from "react-icons/fi";
import {GrBookmark, GrList, GrSort} from 'react-icons/gr' 
import {FiPlusCircle} from 'react-icons/fi'
 import {RiListCheck2} from 'react-icons/ri'
import { BsBarChart, BsGrid, BsSortDown, BsSortUp } from 'react-icons/bs' 
import { jobTypes, priceRanges, timeRanges } from "./mock";
import { SelectDropdown } from "../../../@shared/elements/select";
   

 
  export const Filtering = () =>{
   
    return (
        <div className='project-filtering'>
            <div className="selects">
              <div className="flex-start">
        
                <SelectDropdown data={timeRanges} />
                <SelectDropdown data={jobTypes} />
                <SelectDropdown title="15 miles" data={priceRanges} />
                <SelectDropdown title="More" mega />
  
              </div>
            
                <div className="flex-end">
                      <div className="button green" >
                          <FiPlusCircle /> All Filters
                    </div>
                </div>
            </div>
        </div>
    )
  }
  
  export const FilterTabs = () =>{
    return (
        <div className='project-filtering'>
            <div className="subfilter">
              <div className="wrapper">
                <ul className="buttons">
                  <li className="active">All</li>
                  <li>Pro Services</li>
                  <li>Nearbies</li>
                  <li>Onlines</li>
                </ul>
                <ul className="actions"> 
                  <li>
                     <FiClock />  <p>By date</p>
                      <div className="dropdown">
                        <h3 className="title">View</h3>
                        <ul>
                            <li>
                              <label>
                                  <input type="radio" name="filter-view" />
                                  <label htmlFor='filter-view' ></label>
                                  <RiListCheck2 /> <p>List</p>
                              </label>
                            </li>
                            <li>
                              <label>
                                  <input type="radio" name="filter-view" />
                                  <label htmlFor='filter-view' ></label>
                                  <GrList /> <p>List 2</p>
                              </label>
                            </li>
                            <li>
                              <label>
                                  <input type="radio" name="filter-view" />
                                  <label htmlFor='filter-view' ></label>
                                  <GrSort /> <p>List 3</p>
                              </label>
                            </li>
                            <li>
                              <label>
                                  <input type="radio" name="filter-view" />
                                  <label htmlFor='filter-view' ></label>
                                  <BsGrid /> <p>Grid</p>
                              </label>
                            </li>
                        </ul>
                      </div>
                  </li> 
                  <li>
                     <BsBarChart />  <p> List </p>
                     
                     <div className="dropdown">
                       <h3 className="title">View</h3>
                        <ul>
                          <li>
                            <label>
                                <input type="radio" name="filter-list" />
                                <label htmlFor='filter-list' ></label>
                                <FiClock /> <p>Ascendent</p>
                            </label>
                          </li>
                          <li>
                            <label>
                                <input type="radio" name="filter-list" />
                                <label htmlFor='filter-list' ></label>
                                <FiClock /> <p>Descendent</p> 
                            </label>
                          </li>
                          <li>
                            <label>
                                <input type="radio" name="filter-list" />
                                <label htmlFor='filter-list' ></label>
                                <BsSortUp /> <p>By name (A-Z)</p>
                            </label>
                          </li>
                          <li>
                            <label>
                                <input type="radio" name="filter-list" />
                                <label htmlFor='filter-list' ></label>
                                <BsSortDown /> <p>By name (Z-A)</p>
                            </label>
                          </li>
                        </ul>
                      </div>
                    
                  </li>
                  <li>
                     <GrBookmark />  <p> Save </p>
                  </li>
                </ul>
              </div>
            </div>
        </div>
    )
  }
 